import React, { FC } from "react";
import { BadgeStyled } from "./elements";

type BadgeProps = { count: number };

const Badge: FC<BadgeProps> = (props) => {

  const { count } = props;

  return <BadgeStyled count={count} />;
};

export default Badge;
